export enum TextWidth {
    STANDARD = 'Standard',
    WIDE = 'Wide',
}

export type ContentfulImageOrVideoData = {
    file: {
        contentType: string;
        url: string;
    };
    description: string;
};

export type ContentfulPageType = {
    slug: string;
    image: ContentfulImageOrVideoData;
    link_text: string;
    description: string;
    structured_data?: Record<string, unknown>;
    page_title?: string;
    content_components: Record<string, unknown>[];
};

export const getColClassNames = (textWidth: TextWidth, isImageLeft: boolean) => {
    let leftMd, rightMd;
    if (textWidth === TextWidth.WIDE) {
        if (isImageLeft) {
            leftMd = 'col-md-4';
            rightMd = 'col-md-8';
        } else {
            leftMd = 'col-md-8';
            rightMd = 'col-md-4';
        }
    } else {
        if (isImageLeft) {
            leftMd = 'col-md-6';
            rightMd = 'col-md-6';
        } else {
            leftMd = 'col-md-6';
            rightMd = 'col-md-6';
        }
    }

    return {
        leftMd,
        rightMd,
    };
};
